import { useTranslation } from 'react-i18next';

import {
  RegistrationStatus,
} from '__generated__/graphql';

import { UIProps } from '../../theme/mixins';
import SC from '../../common/UI/SC';
import UI from '../../common/UI';

interface RegistrationStatusLabelProps extends SC<UIProps> {
  status: RegistrationStatus;
}

const RegistrationStatusLabel = ({ status, sc }: RegistrationStatusLabelProps) => {
  const { t } = useTranslation();

  if (status === RegistrationStatus.waitlist) {
    return (
      <UI.Label sc={{ small: true, ...sc }}>
        <UI.Icon>
          <UI.Icons.Hourglass />
        </UI.Icon>
        {' '}
        {t('waitlist')}
      </UI.Label>
    );
  }

  if (status === RegistrationStatus.preregistration) {
    return (
      <UI.Label sc={{ small: true, ...sc }}>
        <UI.Icon>
          <UI.Icons.Pending />
        </UI.Icon>
        {' '}
        {t('preregistration')}
      </UI.Label>
    );
  }

  return <></>;
};

export default RegistrationStatusLabel;
